module.exports = {"title":"Link·Life","open":"Open","openButton":"Open MyLink to see more","download":"Download MyLink APP","ios":"Please click “…”button,  Choose “Open in Safari”","android":"Please click “…”button,  Choose “Open with Browser”","downloadApp":"Download Mylink to browse more information now","register":"Open MyLink APP"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/share/en.json
// module id = 8evm
// module chunks = 1